import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

const InputController = React.forwardRef(function InputController(props, ref) {
  // Extract name from register result so Controller always gets a defined name string.
  const registerName = (props.register || {}).name;
  const resolvedName = props.name ?? registerName ?? '';

  const attachRef = (fieldRef) => (node) => {
    if (typeof fieldRef === 'function') fieldRef(node);
    else if (fieldRef && 'current' in fieldRef) fieldRef.current = node;
    if (typeof ref === 'function') ref(node);
    else if (ref && 'current' in ref) ref.current = node;
  };

  return (
    <Controller
      name={resolvedName}
      control={props.control}
      rules={props.rules || { required: true }}
      defaultValue={props.defaultValue ?? ''}
      render={({ field }) => (
        <TextField
          onChange={(value) => {
            field.onChange(value);
            if (typeof props.changeHandler === 'function') {
              props.changeHandler(value);
            }
            if (props.onFieldChange) {
              props.onFieldChange(value);
            }
          }}
          value={
            props.value === undefined
              ? field.value ?? ''
              : props.value ?? ''
          }
          inputRef={attachRef(field.ref)}
          InputLabelProps={{ shrink: true }}
          label={props.placeholder}
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{props.symbol}</InputAdornment>
            ),
          }}
          type={props.type}
          fullWidth
          error={props.error ? true : false}
          disabled={Boolean(props.disabled)}
        />
      )}
    />
  );
});

export default InputController;
